import { Id, Resource } from '@nextforce/api'
import { createContext, useContext, useState } from 'react'

interface ShareResourceContextType {
  selectedConversationIds: Id[]
  setSelectedConversationIds: React.Dispatch<React.SetStateAction<Id[]>>
  selectedRecipientIds: Id[]
  setSelectedRecipientIds: React.Dispatch<React.SetStateAction<Id[]>>
  selectedResourceId: Id | undefined
  setSelectedResourceId: (id: Id | undefined) => void
  selectedResourceType: Resource['type'] | undefined
  setSelectedResourceType: (type: Resource['type'] | undefined) => void
}

const ShareResourceContext = createContext<ShareResourceContextType>(
  {} as ShareResourceContextType
)

export const ShareResourceProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [selectedResourceId, setSelectedResourceId] = useState<Id | undefined>(
    undefined
  )
  const [selectedResourceType, setSelectedResourceType] = useState<
    Resource['type'] | undefined
  >(undefined)
  const [selectedConversationIds, setSelectedConversationIds] = useState<Id[]>(
    []
  )
  const [selectedRecipientIds, setSelectedRecipientIds] = useState<Id[]>([])

  return (
    <ShareResourceContext.Provider
      value={{
        selectedConversationIds,
        setSelectedConversationIds,
        selectedRecipientIds,
        setSelectedRecipientIds,
        selectedResourceId,
        setSelectedResourceId,
        selectedResourceType,
        setSelectedResourceType,
      }}
    >
      {children}
    </ShareResourceContext.Provider>
  )
}

export const useShareResourceContext = () => useContext(ShareResourceContext)
